import actionTypes from './actionTypes';

const initialState = {
  sessionId: '',
  total: '',
  card: '',
  type: '',
  rate: '',
  price: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case `${actionTypes.GET_STRIPE_SESSION}_SUCCESS`: {
      const { sessionId } = action;
      return {
        ...state,
        sessionId,
      };
    }

    case `${actionTypes.UPGRADE_COST}_SUCCESS`: {
      const {
        total,
        last_4: card,
        card_brand: type,
        previous_rate: rate,
        previous_price: price,
      } = action.payload;
      return {
        ...state,
        total: total || '',
        card: card || '',
        type: type || '',
        rate: rate || '',
        price: price || '',
      };
    }
    default: {
      return state;
    }
  }
};
